// extracted by mini-css-extract-plugin
module.exports = {"prg881n":"prg881n","b1btlj5u":"b1btlj5u","w12kxl7t":"w12kxl7t","w9k8ad0":"w9k8ad0"};